import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../components/DataNotFound';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import DatePickerLayout from '../../../../components/elements/DatePicker';
import { postAsync, putAsync, reactURL } from '../../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../../components/helper/downloadCSVHelper';
import { uuid4 } from '../../../../libs';
import { PageHitCountApi } from '../../../../shared/Helper';
import { printTable } from '../../../../utils/tableExportUtils';
const SDPublishProjectList = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const todayDate = new Date();

  const [apiData, setApiData] = useState([]);
  const [applicantName, setApplicantName] = useState('');
  const [applicantMobile, setApplicantMobile] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [applicantMobileName, setApplicantMobileName] = useState([]);
  const [recordId, setRecordId] = useState([]);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [next, setNext] = useState(1);

  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const token = localStorage.getItem('token');
  const epUser = localStorage.getItem('apid');

  const isLogin = () => {
    if (!token && !epUser) {
      navigate('/managementLogin');
    }
  };

  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, []);

  const SearchFilters = {
    epUserID: 0,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
    dateTo: moment(dateTo).format('DD/MM/YYYY'),
    applicantNameOrMobile: applicantName ? applicantName : applicantMobile,
  };

  const getData = async () => {
    setIsLoad(true);
    setDatanotfound(false);
    await postAsync(
      'ServiceDead/GetSDPublishProjectFilterList/' + pageOptions.pageNo + '/' + pageOptions.pageSize,
      SearchFilters,
    )
      .then((response) => {
        setIsLoad(false);
        setPageCount(response?.page);
        setNext(pageOptions.pageNo);

        if (response?.data != null) {
          const uniqueResult = response?.data.filter(
            (item, index, self) => index === self.findIndex((t) => t.applicantName === item.applicantName),
          );
          setApplicantMobileName(uniqueResult);
          const idArry = [];
          response?.data.forEach((element) => {
            idArry.push(element?.serviceDeadID);
          });

          getRecodId(idArry);
          setApiData(response?.data);
          if (response?.statusCode == 204) {
            setDatanotfound(true);
          }
        } else {
          if (response?.statusCode == 204) {
            setDatanotfound(true);
          }
          setApiData(response?.data);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };
  const getRecodId = async (idArry) => {
    await postAsync('APIClient/GetSdByIds', idArry)
      .then((response) => {
        setRecordId(response?.data);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    isLogin();
    getData();
  }, []);

  const handleOnExport = (e) => {
    e.preventDefault();
    const filteredData = apiData?.map((item, ii) => ({
      'S.No': ii + 1,
      'Applicant Name': item.applicantName,
      'Project Name': item.newProjectName,
      Date: item.date,
      Status: item?.publishID === 1 ? t('Published') : t('Not Published'),
    }));

    downloadCSV(filteredData, 'SDPublishProjectList');
  };

  // const handlePrint = (e) => {
  //   e.preventDefault();
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('Service For Dead Publish Project List')}`; // Replace with your desired heading text
  //   tableContainer.appendChild(heading);

  //   const table = document.createElement('table');
  //   table.style.width = '100%';
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">

  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t('Applicant Name')}</th>

  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Project Name`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Date`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Status`)}</th>

  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData
  //       .map(
  //         (data, index) => `
  //           <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //             <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.applicantName}</td>

  //             <td style="padding: 5px; border: 1px solid #ddd;">${isActive ? data?.newProjectName : data?.newProjectName}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.date}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.publishID === 1 ? t('Published') : t('Not Published')}</td>

  //           </tr>
  //         `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS to hide everything except the table when printing
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {

  //     body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }
  //     .tableData {
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //       width: 100%;
  //       height: auto;
  //       overflow: visible;
  //     }
  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog
  //   window.print();

  //   // Clean up by removing the table container and style from the DOM
  //   document.body.removeChild(tableContainer);
  //   document.head.removeChild(style);

  //   return 'success';
  // };
const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
    {
      header: t('Applicant Name'),
      accessor: (row) => isActive ? row?.applicantName : row?.applicantName
    },
     {
      header: t('Project Name'),
      accessor: (row) => isActive ? row?.newProjectName : row?.newProjectName
    },   {
      header: t('Date'),
      accessor: (row) => isActive ? row?.date  || 'N/A' : row?.date  || 'N/A'
    },   {
      header: t('Status'),
     accessor: (row) => row?.publishID === 1 ? t('Published') : t('Not Published')

    }

  ];
  
  // Call the reusable print function
  printTable({
    data: apiData || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('Service For Dead Publish Project List')} `,
    columns: columns,
    onBeforePrint: () => {
      console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};
  const displayRecords = apiData?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;
    return (
      <Table.Row key={uuid4()} items={apiData}>
        <Table.Cell>{sno}</Table.Cell>
        <Table.Cell>{data?.applicantName}</Table.Cell>
        {/* <Table.Cell>{data?.newProjectTypeName}</Table.Cell> */}
        <Table.Cell>{isActive ? data?.newProjectName : data?.newProjectName}</Table.Cell>
        <Table.Cell>{data?.date}</Table.Cell>
        <Table.Cell>{t(`${data?.publishID === 1 ? 'Published' : 'Not Published'}`)}</Table.Cell>
        <Table.Cell>
          {recordId?.map(
            (value) =>
              value?.id === data.serviceDeadID && (
                <button
                  className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                  onClick={(e) => handlePublish(data)}
                >
                  {t('Publish')}
                </button>
              ),
          )}
        </Table.Cell>
      </Table.Row>
    );
  });

  const changePage = async ({ selected }) => {
    const select = selected + 1;

    await postAsync('ServiceDead/GetSDPublishProjectFilterList/' + select + '/' + pageOptions.pageSize, bodyGet)
      .then((response) => {
        setPageCount(response.page);
        setApiData(response?.data);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handlePublish = async (data) => {
    const link = `${reactURL}/PaymentProcess/${data?.projectID}/${data.referralLink}/${4}`;
    const payload = {
      publishedStatus: 1,
      projectName: data.newProjectName,
      Mobile: data.applicantMobile,
      applicantName: data.applicantName,
      link: link,
    };

    await putAsync('ServiceDead/UpdateSDPublished/', payload, { id: data.serviceDeadID })
      .then((response) => {
        getData();
        toast.success(`${t('Published')}`);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handleSelectApplicant = (e, newValue) => {
    e.preventDefault();
    setApplicantName(newValue?.applicantName);
    setApplicantMobile(newValue?.applicantMobile);
  };

  const handleDateChange = (key, date) => {
    if (key === 'from') {
      // setStartDateFrom(date);
      setDateFrom(date?.toISOString().split('T')[0]);
    }
    if (key === 'to') {
      // setStartDateTo(date);
      setDateTo(date?.toISOString().split('T')[0]);
    }
  };

  return (
    <>
      {!isLogin ? (
        <h1>NOT AUTHORIZED</h1>
      ) : (
        <div className="">
          <div className="container-fluid ">
            <div className="row justify-center flex-row py-5 mt-3">
              {/* <div className="col-lg-11">
                <div className="shadow-md  rounded-md">
                  <div className="card-header text-center">
                    <h3 className="font-bold sm:text-2xl p-2 text-xl text-customgreen" style={{ textAlign: 'center' }}>
                      {t('Service For Dead Publish Project List')}
                    </h3>
                  </div>
                  <div className="card-body md:p-10 ">
                    <div className="row pb-4">
                      <div className=" col-lg-6  my-2">
                        <div className="form-group flex flex-col gap-2 ">
                          <DatePickerLayout
                            label={'Date From'}
                            selectedDate={dateFrom}
                            keyValue={'from'}
                            dateFrom={dateFrom}
                            setDateFrom={setDateFrom}
                            maxDate={todayDate}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6  my-2">
                        <div className="form-group flex flex-col gap-2 ">
                          <DatePickerLayout
                            label={'Date To'}
                            selectedDate={dateTo}
                            keyValue={'to'}
                            dateTo={dateTo}
                            setDateTo={setDateTo}
                            minDate={dateFrom}
                            maxDate={todayDate}
                          />
                        </div>
                      </div>

                      <div className="col-lg-12 my-2">
                        <Autocomplete
                          className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                          options={applicantMobileName}
                          getOptionLabel={(option) => `( ${option?.applicantName})  ${option?.applicantMobile}`}
                          onChange={(e, value) => handleSelectApplicant(e, value)}
                          closeText={getData}
                          renderInput={(params) => <TextField {...params} label={t('Applicant Name / Mobile')} />}
                        />
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group px-6 pt-7 text-center">
                          <button
                            className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2 text-center"
                            onClick={() => getData()}
                          >
                            {t('Search')}
                          </button>
                        </div>
                      </div>

                      <div className="col-lg-12 flex justify-center md:justify-end gap-2 mt-5">
                        <div className="flex justify-center md:flex-row md:justify-end gap-2">
                          <button
                            className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2 text-center"
                            onClick={(e) => handlePrint(e)}
                          >
                            {t('Print')}
                          </button>
                        </div>
                        <div className="flex justify-center md:flex-row md:justify-end gap-2">
                          <button
                            className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2 text-center"
                            onClick={(e) => handleOnExport(e)}
                          >
                            {t('Export')}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="col-12 col-lg-11">
                <div className="shadow-md rounded-md">
                  <div className="card-header text-center">
                    <h3 className="font-bold sm:text-2xl p-2 text-xl text-customgreen" style={{ textAlign: 'center' }}>
                      {t('Service For Dead Publish Project List')}
                    </h3>
                  </div>
                  <div className="card-body px-3 md:px-10">
                    <div className="row pb-4">
                      {/* Date From */}
                      <div className="col-12 col-sm-6 col-md-6 col-lg-6 my-2">
                        <div className="form-group flex flex-col gap-2 ">
                          <DatePickerLayout
                            label={'Date From'}
                            selectedDate={dateFrom}
                            keyValue={'from'}
                            dateFrom={dateFrom}
                            setDateFrom={setDateFrom}
                            maxDate={todayDate}
                          />
                        </div>
                      </div>

                      {/* Date To */}
                      <div className="col-12 col-sm-6 col-md-6 col-lg-6 my-2">
                        <div className="form-group flex flex-col gap-2 ">
                          <DatePickerLayout
                            label={'Date To'}
                            selectedDate={dateTo}
                            keyValue={'to'}
                            dateTo={dateTo}
                            setDateTo={setDateTo}
                            minDate={dateFrom}
                            maxDate={todayDate}
                          />
                        </div>
                      </div>

                      {/* Autocomplete */}
                      <div className="col-12 my-2">
                        <Autocomplete
                          className="border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen"
                          options={applicantMobileName}
                          getOptionLabel={(option) => `( ${option?.applicantName})  ${option?.applicantMobile}`}
                          onChange={(e, value) => handleSelectApplicant(e, value)}
                           closeText={getData}
                          // onOpen={getData}
                          renderInput={(params) => <TextField {...params} label={t('Applicant Name / Mobile')} />}
                        />
                      </div>

                      {/* Search Button */}
                      <div className="col-12 text-center">
                        <div className="form-group px-6 pt-7">
                          <button
                            className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2 text-center"
                            onClick={() => getData()}
                          >
                            {t('Search')}
                          </button>
                        </div>
                      </div>

                      {/* Print and Export Buttons */}
                      <div className="col-12 flex justify-center md:justify-end gap-2 mt-5">
                        <div className="flex justify-center md:flex-row md:justify-end gap-2">
                          <button
                            className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2 text-center"
                            onClick={(e) => handlePrint(e)}
                          >
                            {t('Print')}
                          </button>
                        </div>
                        <div className="flex justify-center md:flex-row md:justify-end gap-2">
                          <button
                            className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2 text-center"
                            onClick={(e) => handleOnExport(e)}
                          >
                            {t('Export')}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="pb-5  row justify-center ">
                {isLoad ? (
                  <LoadingAnimation />
                ) : (
                  <div className="col-lg-11 text-center pt-9">
                    <div class="relative overflow-x-auto  shadow-md sm:rounded-lg">
                      <Table className="text-sm tableData text-left rtl:text-right ">
                        <Table.Header className="font-bold text-white bg-customgreen uppercase ">
                          <Table.Row className=" whitespace-nowrap">
                            <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Applicant Name')}</Table.HeaderCell>
                            {/* <Table.HeaderCell className="text-white">{t('Project Type')}</Table.HeaderCell> */}
                            <Table.HeaderCell className="text-white">{t('Project Name')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Date')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Status')}</Table.HeaderCell>
                            <Table.HeaderCell className="text-white">{t('Action')}</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>

                        <Table.Body>{displayRecords}</Table.Body>
                      </Table>
                      {datanotfound && <DataNotFound />}
                    </div>
                    {pageCount > 0 && (
                      <div className="flex flex-row px-12 justify-between">
                        <Menu pagination>
                          <Menu.Item>
                            <ReactPaginate
                              previousLabel={t('Previous')}
                              nextLabel={t('Next')}
                              pageCount={pageCount}
                              onPageChange={changePage}
                              containerClassName={'paginationButtons'}
                              previousLinkClassName={'previousButton'}
                              nextLinkClassName={'nextButton'}
                              disabledClassName={'paginationDisabled'}
                              activeClassName={'paginationActive'}
                            />
                          </Menu.Item>
                        </Menu>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SDPublishProjectList;
